import { render, staticRenderFns } from "./EmailConfirmed.vue?vue&type=template&id=17bc5fda&scoped=true&"
import script from "./EmailConfirmed.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmed.vue?vue&type=script&lang=ts&"
import style0 from "./EmailConfirmed.vue?vue&type=style&index=0&id=17bc5fda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc5fda",
  null
  
)

export default component.exports